import { render, staticRenderFns } from "./SurveyAdd.vue?vue&type=template&id=1abbc05c&scoped=true"
import script from "./SurveyAdd.vue?vue&type=script&lang=js"
export * from "./SurveyAdd.vue?vue&type=script&lang=js"
import style0 from "./SurveyAdd.vue?vue&type=style&index=0&id=1abbc05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abbc05c",
  null
  
)

export default component.exports